/**
 * WordPress dependencies
 */
import { store, getContext } from '@wordpress/interactivity';

const { state } = store( 'school-directory', {
	actions: {
		filterByCity( e ) {
			const context = getContext();
			const city = e.target.value;

			if( city === '' ) {
				context.filteredDistricts = state.districts;
				return;
			}

			context.filteredDistricts = state.districts.filter( ( district ) => {
				return district.city === city;
			} );
		},
		filterByDistrict( e ) {
			const context = getContext();
			const districtName = e.target.value;

			if( districtName === '' ) {
				context.filteredDistricts = state.districts;
				return;
			}

			context.filteredDistricts = state.districts.filter( ( district ) => {
				return district.post_title.includes( districtName );
			} );
		},
		filterBySchoolPersonnel( e ) {
			const personnelName = e.target.value;
			const context = getContext();

			if( personnelName === '' ) {
				context.filteredDistricts = state.districts;
				return;
			}

			context.filteredDistricts = state.districts.filter( ( district ) => {
				return Object.values( district.school_personnel ).find( ( personnel ) => personnel.name.toLowerCase().includes( personnelName.toLowerCase() ) );
			} );
		}
	},
	callbacks: {
		renderDistricts: () => {
			const { filteredDistricts } = getContext();
			// Render the filtered districts.

			const districtList = document.querySelector( '.directory-list' );
			districtList.innerHTML = '';

			for ( const district of filteredDistricts ) {
				const district_name = district.post_title;
				// Render the filtered districts.
				let template = `
					<div class='district-entry'>
						<h2><a href='${district.url}'>${district_name}</a></h2>
					</div>
				`;

				districtList.innerHTML += template;
			}
		}
	},
	init: {
		
	}
} );
